module.exports = __webpack_public_path__ + "static/media/38.88dc3215.mp3";